import {
   ChangeDetectionStrategy,
   ChangeDetectorRef,
   Component,
   Inject,
   LOCALE_ID,
   OnChanges,
   ViewEncapsulation,
} from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { ReportParameterFormFactoryService } from '@ndt/reports/shared/report-parameter-list/services/report-parameter-form-factory.service';
import { Store } from '@ngrx/store';
import { interval } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { extensionsRoute } from 'src/app/app-routing.module';
import { DashboardTile } from 'src/app/pages/dashboard/models/dashboard-tile.model';
import { Tiles } from '../../containers//tile-wrapper/tile-component-accessor';
import { TileBase } from '../shared/tile-base';
import { RunCallParking_runCallParkingTile } from './queries/generated/RunCallParking';
import { CallParkingParametersFormService } from './services/call-parking-parameters-form.service';

@Component({
   encapsulation: ViewEncapsulation.None,
   changeDetection: ChangeDetectionStrategy.OnPush,
   selector: 'ndt-call-parking-tile',
   styleUrls: ['./call-parking-tile.component.scss'],
   templateUrl: './call-parking-tile.component.html',
   host: {
      class: 'call-parking-table-tile-wrapper',
   },
   standalone: false,
})
export class CallParkingTileComponent
   extends TileBase<CallParkingParametersFormService, RunCallParking_runCallParkingTile>
   implements OnChanges
{
   accountId: number | null = null;
   callParkingData: any = [];
   columns = ['callerIdInformation', 'parkingSlotNumber', 'parkerExtension', 'parkDateTime'];

   constructor(
      @Inject(LOCALE_ID) private locale: string,
      protected formServiceFactory: ReportParameterFormFactoryService,
      protected store: Store,
      public changeDetectorRef: ChangeDetectorRef,
      protected fb: UntypedFormBuilder,
      protected router: Router
   ) {
      super(formServiceFactory, store, changeDetectorRef, fb, router);
      this.formService = formServiceFactory.getService(Tiles.CallParking);

      interval(100)
         .pipe(takeUntil(this.destroyed$))
         .subscribe(() => {
            this.refresh();
            this.changeDetectorRef.markForCheck();
         });
   }

   ngOnChanges(): void {
      this.refresh();
   }

   get rowHeight(): number {
      return this.getTileTableRowHeight(this.tileConfig);
   }
   getFontSizeClass(): string | undefined {
      const width: number = this.tileConfig?.dashboardTileLayoutConfiguration?.width;

      switch (width) {
         case 1:
            return '';
         case 2:
            return 'clock-font-2';
         case 3:
            return 'clock-font-3';
         default:
            return 'clock-font-max';
      }
   }

   private refresh(): void {
      if (this.tileData?.data?.accountId) {
         this.accountId = this.tileData?.data?.accountId;
         this.callParkingData = this.tileData?.data.callParkingLots;
      }
   }

   onRefreshTile() {
      this.refresh();
      this.changeDetectorRef.markForCheck();
   }

   getRouterLink(id: number) {
      return `/${extensionsRoute}/${id}`;
   }

   getTileTableRowHeight(tileConfig: DashboardTile | null): number {
      return (tileConfig?.dashboardTileLayoutConfiguration?.height ?? -1) <= 1 ? 25 : 35;
   }
}
